export const GRADE_LABELS: Record<string, string> = {
  M: "Perfeito",
  NM: "Quase perfeito",
  "VG+": "Muito bom",
  VG: "Bom",
  "G+": "Regular",
  G: "Gasto",
  P: "Ruim",
};

/** "M" -> "M · Perfeito" */
export function gradeLabel(grade?: string | null) {
  if (!grade) return "—";
  const label = GRADE_LABELS[grade.trim().toUpperCase()] ?? GRADE_LABELS[grade.trim()];
  return label ? `${grade} · ${label}` : grade;
}
